<app-confirm-delete-alert #confirmaction></app-confirm-delete-alert>
<ion-list style="position: relative;" >
  <ion-grid  style="position: sticky;top: 0;z-index: 100;">
    <ion-row>
      <ion-col size="12" sizeSm="12" > 
          <ion-searchbar  debounce="1" style="--border-radius: 50px;" [placeholder]="manager.Trad.Parse('STR_PLACEHOLDER_SEARCH')"  [(ngModel)]="searchText" class="custom" ></ion-searchbar>
      </ion-col>     
    </ion-row>
  </ion-grid>
    <ion-button style="--color: var(--ion-color-primary-contrast);"  class="card-end-button" expand="block" fill="solid" ion-text-center  (click)="manager.Navi.navigateTo('admin/api',{id:0})" >
      <ion-icon name="add"></ion-icon>
      <ion-label>{{manager.Trad.Parse("STR_CREATE")}}</ion-label>
    </ion-button>
  <ion-item (click)="Data.navigateTo()" *ngFor="let Data of Datas">
    <ion-label class="">      
      <ion-text color="secondary">
        <h2 class="ion-text-wrap">{{Data.Society + " ("+Data.InternalName+")" }}</h2>
      </ion-text>
      <ion-text color="medium" >
        <p style="font-size: 14px;" class="text-ellipsis">{{Data.Link}}</p>
      </ion-text>
      <ion-text  color="primary">
        <p style="font-size: 10px; text-transform: uppercase; font-weight: bold; margin: 0">{{manager.Trad.Parse("STR_CREDITS_LEFT",{Credits:Data?.Credits})}}</p>
      </ion-text>      
    </ion-label>
    
    <ion-label slot="end"  class="">

      <ion-text slot="end" color="danger" *ngIf="!Data.Activate">
        <p style="margin-right: 22px;">{{manager.Trad.Parse("STR_DISABLED")}}</p>
      </ion-text>
      <ion-text slot="end"  *ngIf="!Data.IsSynced && Data.Activate ">
        <p style="margin-right: 22px;">{{manager.Trad.Parse("STR_PENDING_SYNC")}}</p>
      </ion-text>
      <ion-text color="succes" *ngIf="Data.IsSynced && Data.Activate ">
        <p style="margin-right: 22px;">{{manager.Trad.Parse("STR_ENABLED")}}</p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
